import type { AddressInputVariableInterface } from '../hooks/use-create-address'
import type { Country, Region } from '@pylot-data/fwrdschema'

export const getFormatAddressInput = (
    formInput: AddressInputVariableInterface,
    countryBycode: Country[]
) => {
    const regions = countryBycode[0].available_regions as Region[] | undefined

    const {
        firstname,
        lastname,
        company,
        telephone,
        street,
        city,
        postcode,
        country_code,
        default_billing,
        default_shipping,
        comuna_id,
        document_number
    } = formInput

    const formattedAddress: any = {
        firstname,
        lastname,
        company,
        telephone,
        street,
        city,
        postcode,
        country_code,
        default_billing,
        default_shipping,
        comuna_id,
        document_number
    }

    if (regions) {
        const [region] = regions.filter((reg) => {
            return (
                reg.id === Number(formInput?.region) ||
                reg.code === formInput?.region
            )
        })

        formattedAddress.region = {
            region: region?.name,
            region_code: region?.code,
            region_id: region?.id
        }
    } else {
        formattedAddress.region = {
            region: formInput?.region
        }
    }

    return formattedAddress
}
